import { useQuery } from 'react-query';

import { ISelectModel } from 'common/models';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getCurrenciesFromRoot } from 'services/api/apiCalls/rentals';

const getCurrencies = (): Promise<ISelectModel<number>[]> =>
  getCurrenciesFromRoot().then(response => response.data);

export const useCurrenciesQuery = () =>
  useQuery(
    QUERY_KEYS.RENTALS_PARTNER_CURRENCIES,
    getCurrencies,
    { keepPreviousData: true, staleTime: 5 * 60 * 1000 }, //5 minutes
  );
